<div class="col-md-12 BBI-report">
    <span>Want to view complete BBI’s Report for leads and keywords?<a routerLink="/dashboard/BBI-Report">Tap Here!</a></span>
</div>